import {
  LOGIN_SUCCESS,
  LOGOUT,
  LOGIN_FAILED,
  USER_NOTI_ACTIVA,
} from "../actions/action.user";

const initialState = {
  user: JSON.parse(sessionStorage.getItem("user")) || null,
  error: null,
};

function user(state = initialState, { type, payload }) {
  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: payload.user,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        error: payload.error,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
      };
    case USER_NOTI_ACTIVA:
      return {
        ...state,
        user: {
          ...state.user,
          notificacionGlobalActivas: payload,
        },
      };
    default:
      return state;
  }
}

export default user;
